"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllDataSourceValuesByDataSourceId = exports.getDataSourceValuesByDataSourceId = exports.deleteDataSourceValueById = exports.getDataSourceValueById = exports.getAllDataSourceValues = exports.getDataSourceValues = exports.downloadDataSourceValueTemplate = exports.downloadDataSourceValues = exports.putDataSourceValue = exports.uploadDataSourceFile = exports.uploadDataSourceContent = exports.createDataSourceValue = void 0;
var network_1 = require("../network");
var utils_1 = require("../utils");
function createDataSourceValue(_a) {
    var dataSourceId = _a.dataSourceId, content = _a.content;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/data-sources/" + dataSourceId,
                    body: content,
                })];
        });
    });
}
exports.createDataSourceValue = createDataSourceValue;
function uploadDataSourceContent(_a) {
    var dataSourceId = _a.dataSourceId, content = _a.content;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/data-sources/" + dataSourceId + "/batch",
                    body: content,
                })];
        });
    });
}
exports.uploadDataSourceContent = uploadDataSourceContent;
function uploadDataSourceFile(_a) {
    var dataSourceId = _a.dataSourceId, file = _a.file;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePostFile({
                    path: "/data-sources/" + dataSourceId + "/batch",
                    file: file,
                })];
        });
    });
}
exports.uploadDataSourceFile = uploadDataSourceFile;
function putDataSourceValue(_a) {
    var value = _a.value;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simplePost({
                    path: "/data-source-values",
                    body: value,
                })];
        });
    });
}
exports.putDataSourceValue = putDataSourceValue;
function downloadDataSourceValues(_a) {
    var dataSourceId = _a.dataSourceId, mediaType = _a.mediaType;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGetFile({
                    path: "/data-sources/" + dataSourceId,
                    mediaType: mediaType,
                })];
        });
    });
}
exports.downloadDataSourceValues = downloadDataSourceValues;
function downloadDataSourceValueTemplate(_a) {
    var dataSourceId = _a.dataSourceId, mediaType = _a.mediaType;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGetFile({
                    path: "/data-sources/" + dataSourceId + "/upload-template",
                    mediaType: mediaType,
                })];
        });
    });
}
exports.downloadDataSourceValueTemplate = downloadDataSourceValueTemplate;
function getDataSourceValues(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "data-source-values" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.getDataSourceValues = getDataSourceValues;
function getAllDataSourceValues(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "data-source-values/all" + utils_1.buildQueryParams(params),
                })];
        });
    });
}
exports.getAllDataSourceValues = getAllDataSourceValues;
function getDataSourceValueById(_a) {
    var dataSourceKey = _a.dataSourceKey, id = _a.id;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleGet({
                    path: "/data-source-values/" + id + "?dataSourceKey=" + dataSourceKey,
                })];
        });
    });
}
exports.getDataSourceValueById = getDataSourceValueById;
function deleteDataSourceValueById(_a) {
    var dataSourceKey = _a.dataSourceKey, id = _a.id;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2, network_1.simpleDelete({
                    path: "/data-source-values/" + id + "?dataSourceKey=" + dataSourceKey,
                })];
        });
    });
}
exports.deleteDataSourceValueById = deleteDataSourceValueById;
function getDataSourceValuesByDataSourceId(params) {
    return __awaiter(this, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_a) {
            queryParams = utils_1.buildQueryParams(params, ["dataSourceId"]);
            return [2, network_1.simpleGet({
                    path: "/data-sources/" + params.dataSourceId + "/values" + queryParams,
                })];
        });
    });
}
exports.getDataSourceValuesByDataSourceId = getDataSourceValuesByDataSourceId;
function getAllDataSourceValuesByDataSourceId(params) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, network_1.simpleGet({
                    path: "data-sources/" + params.dataSourceId + "/values/all",
                })];
        });
    });
}
exports.getAllDataSourceValuesByDataSourceId = getAllDataSourceValuesByDataSourceId;
//# sourceMappingURL=dataSourceValueResource.js.map